var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { Fragment } from "react";
var Tag = function (_a) {
    var text = _a.text, _b = _a.color, color = _b === void 0 ? "orange" : _b, _c = _a.icon, icon = _c === void 0 ? null : _c, _d = _a.className, className = _d === void 0 ? null : _d;
    return (_jsx(Fragment, { children: _jsxs("span", __assign({ className: "inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-".concat(color, "-100 text-").concat(color, "-800 ").concat(className) }, { children: [icon ? icon : null, text] }), void 0) }, void 0));
};
export default Tag;
